import { render, staticRenderFns } from "./TransferClover.vue?vue&type=template&id=c7457ed2&lang=pug&"
import script from "./TransferClover.vue?vue&type=script&lang=js&"
export * from "./TransferClover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports